import { render, staticRenderFns } from "./OrderItemTrackingProductManagement.vue?vue&type=template&id=38b819ac&scoped=true"
import script from "./OrderItemTrackingProductManagement.vue?vue&type=script&lang=js"
export * from "./OrderItemTrackingProductManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderItemTrackingProductManagement.vue?vue&type=style&index=0&id=38b819ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b819ac",
  null
  
)

export default component.exports